import React, { useState, useEffect } from "react";
import * as projectApi from "../../../api/projectApi";
import { toast } from "react-toastify";
import { ProjectsForm } from "../../forms/Master/ProjectsForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function ProjectsPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(getProjects, []);

  function getProjects() {
    projectApi
      .getAllProjects()
      .then((result) => {
        setIsLoading(false);
        setProjects(result);
      })
      .catch((error) => {
        setIsLoading(false);
        setProjects([]);
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
  }

  function addNewItem() {
    history("/home/projects/project", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(projKey) {
    history("/home/projects/project/" + projKey, {
      state: { currentPage: currentPage },
    });
  }

  function onDelete(projKey) {
    showDeleteConfirm("Project", projKey, deleteProject, t);
  }

  function deleteProject(projKey) {
    setIsLoading(true);
    projectApi
      .deleteProject(projKey)
      .then(() => {
        const newData = projects.filter((item) => item.ProjKey !== projKey);
        setProjects(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_delete_record") + error.message);
      });
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <ProjectsForm
      isLoading={isLoading}
      projects={projects}
      onAdd={addNewItem}
      onEdit={editItem}
      onDelete={onDelete}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

ProjectsPage.propTypes = {
  history: PropTypes.func.isRequired,
};
